import { Button, Stack, TextField } from '@mui/material';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import { EditValidationSchema } from '../utils/EditCsvDataValidation';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { useDispatch } from 'react-redux';
import { postSalaryOrRBonusAndSync } from '../../../../redux/features/CRDslice';

export default function EditCSVData({ row, pageType, month, year, setOpenModal, setRefresh, submitLoading }) {
  const handleApiHelper = useHandleApiResponse();
  const dispatch = useDispatch();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: row?.user_cost_id || '',
      name: row?.ogaName || '',
      ...(pageType === 'bonus' ? { bonus: row?.bonus || '' } : { salary: row?.salary || '' }),
    },
    validationSchema: EditValidationSchema(pageType),
    onSubmit: (values) => {
      dispatch(postSalaryOrRBonusAndSync({ ...values, month, year, path: pageType })).then((res) =>
        handleApiHelper(res, {
          onSuccess: () => {
            setOpenModal(false);
            setRefresh((prev) => !prev);
          },
        }),
      );
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form>
        <Stack gap={1}>
          <Field
            as={TextField}
            type="number"
            onWheel={(e) => e.target.blur()}
            name="id"
            label="ID"
            error={formik.touched.id && Boolean(formik.errors.id)}
            helperText={formik.touched.id && formik.errors.id}
          />
          <Field
            as={TextField}
            name="name"
            label="Name"
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
          <Field
            as={TextField}
            name={pageType === 'bonus' ? 'bonus' : 'salary'}
            label={pageType === 'bonus' ? 'Bonus' : 'Salary'}
            error={
              formik.touched[pageType === 'bonus' ? 'bonus' : 'salary'] &&
              Boolean(formik.errors[pageType === 'bonus' ? 'bonus' : 'salary'])
            }
            helperText={
              formik.touched[pageType === 'bonus' ? 'bonus' : 'salary'] &&
              formik.errors[pageType === 'bonus' ? 'bonus' : 'salary']
            }
          />
          <Button variant="contained" type="submit" disabled={submitLoading}>
            {submitLoading ? 'Updating...' : 'Update'}
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
